import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postPresenceClockOut = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/presences/clock-out`,
    data: payload,
  });

  return data?.data;
};

export default postPresenceClockOut;
